import React, { useEffect, useState } from "react";
import { SendPostRequest } from "../../http";
import { Link } from "react-router-dom";
import Spinner from "../Spinner";
import OwlCarousel from "react-owl-carousel";
import { limitParagraphByCharLimit } from "../../Helper/Helper";

function TrippleStackFacilities() {
  const [facilitiesData, setFacilitiesData] = useState([]);

  useEffect(() => {
    getFacilitiesData();
  }, []);

  const getFacilitiesData = async () => {
    const response = await SendPostRequest("facilities");
    setFacilitiesData(response?.data);
  };

  const options = {
    loop: true,
    nav: false,
    dots: false,
    autoplay: true,
    autoplayTimeout: 2500,
    autoplayHoverPause: true,
    smartSpeed: 1000,
    margin: 30,
    responsive: {
      0: { items: 1 },
      600: { items: 2 },
      1000: { items: 3 },
    },
  };

  return (
    <>
      {facilitiesData?.length > 0 ? (
        <section id="feature-section" className="feature-section pb-4 pt-5">
          <div className="container">
            <div className="row mb-4">
              <div className="offset-md-2 col-md-8">
                <div className="title-wrap text-center">
                  <div className="section-title margin-bottom-40">
                    <h2 className="title mb-0 text-uppercase">
                      Our <span className="theme-color">Facilities</span>
                    </h2>
                    <span className="section-border-bottom center"></span>
                  </div>
                </div>
              </div>
            </div>
            <div className="row" data-animation="fadeInDown">
              {facilitiesData?.length === 0 ? (
                <div
                  style={{ marginBottom: "100px" }}
                  className="d-flex align-items-center justify-content-center"
                >
                  <Spinner />
                </div>
              ) : (
                <OwlCarousel className="service-main-wrapper" {...options}>
                  {facilitiesData?.map((data, index) => (
                    <div key={index} className="item animated fadeInLeft visible">




                      <div class="feature-box-wrap f-box-style-4 relative triplestack-specailities-wrapper">
                        <div class="feature-box-details">
                          <div class="feature-img margin-bottom-25">
                            <img className="img-fluid" src={data?.facility_image}
                              style={{ height: "auto" }} alt="feature img" />
                          </div>
                          <div class="feature-content">
                            <div class="feature-title text-center relative margin-bottom-10">
                              <Link
                                to={`/facility/${data?.facility_slug
                                  ?.replaceAll(" ", "-")
                                  ?.replaceAll("/", "-")}`}
                              >

                                <h5>
                                  {data?.facility_title}
                                </h5>
                              </Link>
                            </div>
                            <p class="mb-0 text-center">  <div
                              className="service-desc text-center mb-4"
                              dangerouslySetInnerHTML={{
                                __html:
                                  limitParagraphByCharLimit(data?.facility_short_description, 70) +
                                  (data?.facility_short_description?.length > 70 ? "..." : ""),
                              }}
                            /></p>
                          </div>
                        </div>
                      </div>



                    </div>
                  ))}
                </OwlCarousel>
              )}
            </div>
          </div>
        </section>
      ) : null}
    </>
  );
}

export default TrippleStackFacilities;